/** CUSTOMER-R4.7-A — customer delivery patch client. */
import { storeV2AuthHeaders } from "./store-v2-auth-headers-v2.js";

export async function updateCustomerDeliveryV2(input: {
  sessionKey: string;
  orderId: string;
  contactName?: string | null;
  contactPhone?: string | null;
  deliveryCity: string;
  deliveryWarehouse: string;
  deliveryMethod?: string | null;
}): Promise<{ ok: boolean; error?: string; message?: string }> {
  try {
    const res = await fetch("/api/store-v2/update-delivery", {
      method: "POST",
      headers: storeV2AuthHeaders({ "Content-Type": "application/json" }),
      body: JSON.stringify({
        session_key: input.sessionKey,
        order_id: input.orderId,
        contact_name: input.contactName ?? null,
        contact_phone: input.contactPhone ?? null,
        delivery_city: input.deliveryCity,
        delivery_warehouse: input.deliveryWarehouse,
        delivery_method: input.deliveryMethod ?? null,
      }),
    });
    const json = (await res.json()) as Record<string, unknown>;
    if (!res.ok || json.ok === false) {
      const failed: { ok: false; error: string; message?: string } = {
        ok: false,
        error: String(json.error ?? `http_${res.status}`),
      };
      if (typeof json.message_uk === "string") failed.message = json.message_uk;
      return failed;
    }
    return { ok: true };
  } catch {
    return { ok: false, error: "network", message: "Немає звʼязку. Спробуйте ще раз." };
  }
}
